import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getImxImrSeasonData from './GetImxImrSeasonData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  options: []
};

const ImxImrSeasonData = {
  INITIAL_STATE, getImxImrSeasonData
}

export default ImxImrSeasonData;